import { ArrowRight, Mail } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { Lang, t } from "../i18n";
import { leadFormPath } from "../routes";
import { reportLeadEntryConversion } from "../tracking";

const contactEmail = "info@clawease.ai";

function demandMailto(lang: Lang) {
  const subject = encodeURIComponent(lang === "zh" ? "ClawEase 需求提交" : "ClawEase request");
  const body = encodeURIComponent(
    lang === "zh"
      ? "你好，我想了解 ClawEase。\n\n需求背景：\n联系方式：\n公司/机构："
      : "Hi, I would like to learn more about ClawEase.\n\nRequest context:\nContact:\nCompany:"
  );

  return `mailto:${contactEmail}?subject=${subject}&body=${body}`;
}

export function CTA({ lang }: { lang: Lang }) {
  const { search } = useLocation();

  return (
    <section id="contact" className="relative px-5 pb-20 pt-14 text-center sm:px-10 lg:pt-16">
      <div className="relative mx-auto max-w-[900px]">
        <div className="mx-auto inline-flex rounded-full bg-[#f3eefa] px-3 py-1 text-[12px] font-extrabold uppercase tracking-[0.12em] text-[#5223b1]">
          {t(lang, "cta.label")}
        </div>
        <h2 className="mt-6 text-[40px] font-extrabold leading-[1.06] tracking-[-0.03em] text-[#100f12] sm:text-[58px] lg:text-[76px]">
          {t(lang, "cta.title.base")}{" "}
          <span
            className="bg-clip-text text-transparent"
            style={{
              backgroundImage: "linear-gradient(90deg, #5223b1 0%, #7823b1 52%, #e930c9 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {t(lang, "cta.title.accent")}
          </span>
        </h2>
        <p className="mx-auto mt-7 max-w-[620px] text-[17px] font-semibold leading-8 text-[#775f78]">
          {t(lang, "cta.sub")}
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link
            to={leadFormPath(lang, undefined, "cta_primary", search)}
            onClick={() => reportLeadEntryConversion(search)}
            className="inline-flex min-h-14 items-center justify-center gap-2 rounded-full bg-[#2a1329] px-8 text-[15px] font-extrabold text-white no-underline shadow-[0_18px_42px_rgba(42,19,41,.18)] transition-transform hover:-translate-y-0.5"
          >
            {t(lang, "cta.button.primary")}
            <ArrowRight size={17} strokeWidth={2.6} />
          </Link>
          <a
            href={demandMailto(lang)}
            onClick={() => reportLeadEntryConversion(search)}
            className="inline-flex min-h-14 items-center justify-center gap-2 rounded-full border border-[#e7dce7] bg-white px-8 text-[15px] font-extrabold text-[#2a1329] no-underline transition-colors hover:bg-[#fbf8fc]"
          >
            <Mail size={17} strokeWidth={2.4} />
            {t(lang, "cta.button.secondary")}
          </a>
        </div>
      </div>
    </section>
  );
}
